// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"552":"chartjs","692":"datatables"}[chunkId] || chunkId) + "." + {"552":"ab6de9e90fa959e5347a","692":"25533835a4863386813e","706":"7a09e3ae0d6082b20210"}[chunkId] + ".js";
};